import { useAuthContext } from '@/contexts/AuthContext';
import { useUserContext } from '@/contexts/UserContext';
import EditSubscriptionLimitsModal from '@/modals/EditSubscriptionLimitsModal';
import SubscriptionPlans from '@/screens/settings/SubscriptionPlans';
import { useEffect, useState } from 'react';
import { CreateCustomPlanModal } from './CreateCustomPlanModal';

export function PlanTab() {
  const { selectedAccount } = useUserContext();
  const { isSupportAdmin } = useAuthContext();
  const [showCustomPlanModal, setShowCustomPlanModal] = useState(false);
  const [showEditLimitsModal, setShowEditLimitsModal] = useState(false);

  // Hidden keyboard shortcuts for support admins:
  // Ctrl+Shift+C: Create custom plan
  // Ctrl+Shift+L: Edit subscription limits
  useEffect(() => {
    if (!isSupportAdmin) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        setShowCustomPlanModal(true);
      }
      if (e.ctrlKey && e.shiftKey && e.key === 'L') {
        e.preventDefault();
        setShowEditLimitsModal(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isSupportAdmin]);

  if (selectedAccount?.data().billing?.currentPlan === 'custom') {
    return (
      <>
        <h2 className="mb-4 text-xl font-semibold">Custom Plan</h2>
        <p className="text-base text-[#344051]">
          You are currently on a Custom Plan. For any changes to your plan,
          please contact our support team at{' '}
          <a href="mailto:support@superfunnel.ai?subject=Enterprise Plan Inquiry">
            support@superfunnel.ai
          </a>
          .
        </p>

        {isSupportAdmin && (
          <>
            <CreateCustomPlanModal
              isOpen={showCustomPlanModal}
              onClose={() => setShowCustomPlanModal(false)}
            />
            <EditSubscriptionLimitsModal
              open={showEditLimitsModal}
              onClose={() => setShowEditLimitsModal(false)}
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      <SubscriptionPlans whiteMode />

      {isSupportAdmin && (
        <>
          <CreateCustomPlanModal
            isOpen={showCustomPlanModal}
            onClose={() => setShowCustomPlanModal(false)}
          />
          <EditSubscriptionLimitsModal
            open={showEditLimitsModal}
            onClose={() => setShowEditLimitsModal(false)}
          />
        </>
      )}
    </>
  );
}
